import React, { useEffect, useState } from 'react';
import { Poppins, Spacer } from 'src/common';
import styled from 'styled-components';
import { Modal } from './comps';
import Button from '../form/Button';

const StyledModal = styled(Modal)`
  width: 566px;
  /* padding: 0; */

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

interface ISessionEndModalProps {
  onClose: () => void;
  minutesRemaining: number;
  expirationTime: string;
}

export const SessionEndModal: React.FC<ISessionEndModalProps> = ({ onClose, minutesRemaining, expirationTime }) => {
  return (
    <StyledModal onRequestClose={onClose} isOpen center noCloseIcon>
      <div className="h-padding">
        <div className="content">
          <Poppins px={18} color="cflowerBlue">
            For security reasons, you will be logged out in
          </Poppins>
          <Spacer $px={4} />
          <Poppins px={18} color="cflowerBlue">
            <Poppins weight={500} px={18}>
              {minutesRemaining} minutes
            </Poppins>{' '}
            at{' '}
            <Poppins weight={500} px={18}>
              {expirationTime}
            </Poppins>
          </Poppins>
          <Spacer $px={40} />
          <Button primary onClick={onClose}>
            OK
          </Button>
        </div>
      </div>
    </StyledModal>
  );
};
